import React, { useState } from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import DoneIcon from '@mui/icons-material/Done';
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Collapse,
  FormControl,
  InputLabel,
  OutlinedInput,
  Typography,
} from '@mui/material';
import { styled } from '@mui/system';

import { useOnClickOutside } from '../../../../common/hooks/UseOnClickedOutside';

export const Feedback = ({
  feedbackHandler,
  show,
}: {
  feedbackHandler: (
    sufficient: boolean,
    feedback: string,
    noOperation: boolean,
  ) => void;
  show: boolean;
}) => {
  const [feedback, setFeedBack] = useState({ sufficent: false, text: '' });
  const [captureFeedback, setcaptureFeedback] = useState({ capture: false });
  const [error, setError] = useState(false);
  const inputRef = React.createRef<HTMLDivElement>();

  useOnClickOutside(inputRef, () => {
    feedbackHandler(false, '', true);
  });

  const onFeedback = (event: React.ChangeEvent<HTMLInputElement>) => {
    setError(false);
    setFeedBack({ sufficent: false, text: event.target.value });
  };

  const completeFeedback = (sufficent: boolean, text: string) => {
    if (text.length === 0 && !sufficent) {
      setError(true);
      return;
    }
    feedbackHandler(sufficent, text, false);
  };

  return (
    <Collapse in={show}>
      <div ref={inputRef}>
        <RootCard>
          <CardActionArea>
            <CardContent>
              <Typography variant="h5" component="h2">
                Provide Feedback
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Did the information provided have everything you were looking
                for? Select an option to complete the task.
              </Typography>
              {!captureFeedback.capture && (
                <Box>
                  <YesButton
                    variant="contained"
                    color="primary"
                    startIcon={<DoneIcon />}
                    onClick={() => {
                      setFeedBack({ sufficent: true, text: '' });
                      completeFeedback(true, '');
                    }}
                  >
                    Yes
                  </YesButton>
                  <NoButton
                    variant="contained"
                    color="primary"
                    startIcon={<ClearIcon />}
                    onClick={() => {
                      setcaptureFeedback({ capture: true });
                      setFeedBack({ sufficent: false, text: '' });
                    }}
                  >
                    No
                  </NoButton>
                </Box>
              )}
              {captureFeedback.capture && (
                <FormControl fullWidth variant="outlined">
                  <InputLabel htmlFor="outlined-adornment-feedback">
                    Feedback
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-feedback"
                    onChange={onFeedback}
                    label="Feedback"
                    error={error}
                  />
                  <SaveButton
                    variant="contained"
                    size="medium"
                    color="primary"
                    onClick={() => {
                      setFeedBack({ sufficent: true, text: feedback.text });
                      completeFeedback(false, feedback.text);
                    }}
                  >
                    Complete
                  </SaveButton>
                </FormControl>
              )}
            </CardContent>
          </CardActionArea>
        </RootCard>
      </div>
    </Collapse>
  );
};

const RootCard = styled(Card)(() => ({
  backgroundColor: '#F4F5F7',
  marginRight: '17%',
}));

const SaveButton = styled(Button)(() => ({
  marginTop: '18px',
  marginRight: '80%',
}));

const YesButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(2),
}));

const NoButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(2),
  backgroundColor: '#FF3B30',
}));
